import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "../../../6729.css";

import image1 from "../../../images/gear/gera-oil/8616/8616_1front.webp";
import image2 from "../../../images/gear/gera-oil/8616/8616_1back.webp";



const images = [
  { src: image1, alt: "Front" },
  { src: image2, alt: "Back" },

];

const packageSlides = [
  { images: [image1, image2] },
 

];

const TDS_URL = "https://www.fanfaro.de/create-pdf/83";


const SDS_FILES = [
  { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(BE).pdf" },
  { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(BG).pdf" },
  { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(CZ).pdf" },
  { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(DE).pdf" },
  { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(DK).pdf" },
  { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(EE).pdf" },
  { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(ES).pdf" },
  { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(FI).pdf" },
  { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(FR).pdf" },
  { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(GR).pdf" },
  { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(HR).pdf" },
  { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(HU).pdf" },
  { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(IE).pdf" },
  { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(IT).pdf" },
  { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(LT).pdf" },
  { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(LV).pdf" },
  { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(NO).pdf" },
  { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(PL).pdf" },
  { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(PT).pdf" },
  { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(RO).pdf" },
  { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(RU).pdf" },
  { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(SE).pdf" },
  { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(SI).pdf" },
  { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF8616_-_FANFARO 8616 DCT_(SK).pdf" }
];




export default function ImageWithContent() {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showSDS, setShowSDS] = useState(false);

  const [packageIndex, setPackageIndex] = useState(0);
  const [imageIndex, setImageIndex] = useState(0);

  const slideInterval = useRef(null);
  const slideDuration = 4000;

  useEffect(() => {
    startSlideTimer();
    return () => clearInterval(slideInterval.current);
  }, []);

  const startSlideTimer = () => {
    slideInterval.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, slideDuration);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
    clearInterval(slideInterval.current);
    startSlideTimer();
  };

  const nextImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev + 1) % total);
  };

  const prevImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
  };

  return (
   <>
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: "32px",
        padding: "24px",
        fontFamily: "Arial",
      }}
    >

      {/* LEFT IMAGE CAROUSEL */}
       <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>


        
        {/* Amazon Button (external link) */}
        <a
          href="https://www.amazon.in/FANFARO-clutch-transmission-Gearbox-Germany/dp/B0866MGBN4/ref=sr_1_1?"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy on Amazon
          </button>
        </a>

      </div>

      {/* RIGHT CONTENT */}
      <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
        <h2>FANFARO DCT 8616</h2>

        <p>
       A special synthetic gear oil (containing PAO) for DCT – dual clutch transmission or “robots”. It is not recommended for gearboxes with a “dry” clutch. It ensures a flawless operation of a gearbox, guarantees minimal wear, a lasting service life and fuel economy.

        </p>

        <p><strong>Product properties:</strong></p>

        <ul style={{ paddingLeft: "20px" }}>
      <li>The unique low-viscosity PAO base of the highest quality in combination with a multifunctional additive package preserves all its properties in a wide range of temperatures: it ensures good lubricating properties at low (-45 °C and less) temperatures in winter and ensures a stable oil film under extreme loads and high temperatures in summer;</li>
  <li>The high-technology combination of additives ensures good antifriction properties for gear couplings and superior friction properties for friction elements thus ensuring a significant fuel economy, a continuous and smooth transmission shift and the increase in the service life of all transmission elements (friction clutches, hydraulic servo drives, synchronizers, gear pairs);</li>
  <li>It has an increased thermal-oxidative stability and an excellent resistance to the high-temperature thermal degradation that allow increasing the time between oil changes and reducing equipment maintenance costs;</li>
  <li>It protects metal parts from ferrous and non-ferrous alloys from corrosion when both in and not in operation;</li>
  <li>It effectively resists aeration and foam formation;</li>
  <li>It provides an excellent compatibility with sealing materials, prevents them from swelling, hardening and shrinking thus reducing the costs for spare parts and preventing leakages;</li>
  <li>It reduces noise.</li>
        </ul> <br />

        <p>
  It is recommended for transmissions of VW/AUDI (S-tronic), BMW, FORD, PEUGEOT/CITROEN, VOLVO, CHRYSLER, DODGE, MITSUBISHI passenger cars and ZF gearboxes, as well as transmissions of commercial vehicles that require a special oil with indicated specifications. <br />

     Colour: yellow-brown. <br />
       Comply with the manufacturer’s instructions provided in the user’s manual!
        </p>


        <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
          CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
        </p>

        {/* SPECIFICATIONS */}
        <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
          <div>
            <b>Specifications</b>
            {/* <ul style={{ paddingLeft: "20px" }}>
              <li>JASO M315, Class 1-A-LV</li>
              
            </ul> */}
          </div>


          <div>
            <b>Recommendation</b>
   <ul style={{ paddingLeft: "20px" }}>
  <li>VOLKSWAGEN G 052 182</li>
  <li>VOLKSWAGEN G 052 529</li>
  <li>BMW 83 22 2 148 578</li>
  <li>BMW 83 22 2 148 579</li>
  <li>BMW 83 22 0 440 214</li>
  <li>BMW 83 22 2 147 477</li>
  <li>FORD WSS-M2C936-A</li>
  <li>MB 236.21</li>
  <li>MB 001 989 85 03</li>
  <li>MITSUBISHI MZ320065</li>
  <li>PORSCHE 999.917.080.00</li>
  <li>PSA 9734.S2</li>
  <li>VOLVO 1161838</li>
  <li>VOLVO 1161839</li>
  <li>VOLKSWAGEN 6-speed</li>
  <li>BMW Drivelogic 7-speed (Getrag)</li>
  <li>BMW DCTF-1/ DCTF-1+</li>
  <li>BMW 6-speed DCT</li>
  <li>BMW MTF-LT-5</li>
  <li>RENAULT EDC 6-speed (Getrag)</li>
  <li>RENAULT EDC-7</li>
  <li>RENAULT Talisman R7D</li>
  <li>CHRYSLER 68044345 EA&amp;GA</li>
  <li>CHRYSLER Powershift 6-speed (Getrag)</li>
  <li>FERRARI 7-speed (Getrag)</li>
  <li>MITSUBISHI TC-SST 6-speed (GFT)</li>
  <li>NISSAN WSS-M2C936-A</li>
  <li>PEUGEOT DCS 6-speed (GFT)</li>
  <li>FERRARI TF DCT-3</li>
  <li>PENTOSIN FFL-8</li>
  <li>Others SHELL TF DCT-F3</li>
  <li>CASTROL 0412042 341</li>
  <li>CASTROL 0412042 450</li>
  <li>BORG_WARNER</li>
  <li>BUGATTI_VEYRON</li>
</ul>
          
          </div>

          <div>
            <b>PACKAGES:</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(0);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  1L (FF8616-1)
                </span>
              </li>

              {/* <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(1);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  20L (FF6201-60)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(2);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  60L (FF6201-DR)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(3);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  208L (FF6201-IBC)
                </span>
              </li> */}

            </ul>
          </div>
          <div>
            <b>SDS & TDS</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSDS(true);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  📄 SDS
                </a>
              </li>

              <li>
                <a
                  href="https://www.fanfaro.de/create-pdf/83"
                  target="_blank"
                  style={{ textDecoration: "none" }}>
                  🖨️ TDS
                </a>
              </li>

            </ul>
          </div>

        </div>



      </div>

      {/* MODAL */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              width: "500px",
              borderRadius: "8px",
              position: "relative",
            }}
          >

            <span
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                right: "15px",
                top: "10px",
                cursor: "pointer",
                fontSize: "22px",
              }}
            >
              ✕
            </span>

            <img
              src={packageSlides[packageIndex].images[imageIndex]}
              alt="package"
              style={{
                width: "100%",
                maxHeight: "450px",
                objectFit: "contain",
              }}
            />

            <div style={{ textAlign: "center", marginTop: "20px" }}>

              <button onClick={prevImage}>◀</button>

              <span style={{ margin: "0 15px" }}>
                {imageIndex + 1} of {packageSlides[packageIndex].images.length}
              </span>

              <button onClick={nextImage}>▶</button>

            </div>

          </div>
        </div>
      )}

      {showSDS && (
        <div className="sds-overlay" onClick={() => setShowSDS(false)}>
          <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
            {/* Close Icon */}
            <button
              className="sds-close-icon"
              onClick={() => setShowSDS(false)}
              aria-label="Close SDS"
            >
              ×
            </button>

            <h3>FANFARO M-4T Plus</h3>

            <div className="sds-grid">
              {SDS_FILES.map((file) => (
                <a
                  key={file.code}
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {file.code}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>

    <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
   </>
  );
}